// import QRCode from "react-qr-code";
// import Barcode from "react-barcode";
import { useCardPrint } from "./useCardPrint";

import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';
import QR from "qrcode-base64";
import QRCode from "react-qr-code";
export const StaticHtmlTemplateE = ({value, sideMargin = 0, topMargin = 0}) => {

  const { renderText, checkSyleCode } = useCardPrint();
  // sideMargin (A3/A5 cut-margin) is baked INTO the card: the box widens by 2*margin so the
  // colored header/footer/background bleed to the cut edge, while the text body is inset by the
  // same margin so it isn't clipped when the client hand-cuts. sideMargin 0 (A4) => unchanged.
  const m = sideMargin || 0;
  const cardW = 321 + 2 * m;
  // topMargin is the TOP-edge cut-margin: the box grows upward by t while the whole design is
  // pushed down by the same px, so the added strip is filled by the stretched background image
  // and no artwork moves or distorts. The card is cut 207px up from the box BOTTOM.
  // topMargin 0 => card stays 207 tall.
  const t = topMargin || 0;
  const cardH = 207 + t;
  // footer_type 3 prints the barcode on top of the footer background image; the text colour of
  // the whole card follows text_color, falling back to black when the report leaves it empty.
  const isFooterWithBarcode = parseInt(value?.footer_type) === 3;
  const outerStyle = {
    ...styles.outer_wrapper,
    width: cardW,
    minWidth: cardW,
    maxWidth: cardW,
    height: cardH,
    minHeight: cardH,
    maxHeight: cardH,
    color: value?.text_color || "#000000",
  };
  const headerImgStyle = { ...styles.header_img, maxWidth: cardW };
  const bodyStyle = { ...styles.body, paddingLeft: 7 + m, paddingRight: 7 + m };
  const qrWrapStyle = { ...styles.qr_wrap, right: styles.qr_wrap.right + m };

  const arrayItems = value?.data?.graded_values;
  const isLargeArray = arrayItems?.length > 8;

  const topArray = arrayItems?.filter(item => parseInt(item?.section) === 1);
  const middleArray = arrayItems?.filter(item => parseInt(item?.section) === 2);
  const bottomArray = arrayItems?.filter(item => parseInt(item?.section) === 3);
  
  //to change the length of key
  const maxKeyLength = arrayItems?.reduce((max, str) => Math.max(max, str?.text?.length), 0);
  const newKeyValue = {
    ...styles.key,
    width : maxKeyLength >= 13 ? 80 : 75,
  }
  //end to change the length of key

  const parser = new DOMParser();

  const generateBarcodeBase64 = (value, background = "#ffffff") => {
    const canvas = createCanvas();
    JsBarcode(canvas, value, {
      format: "CODE128", // Barcode type
      width: 1,
      height: 15,
      margin : 0,
      background, // transparent when it sits on top of the footer image
      displayValue: false // Set to true if you want to display the number below
    });
  
    // Convert the canvas to a base64 string
    return canvas.toDataURL("image/png");
  };
  
  const barcodeData = generateBarcodeBase64(
    value?.certificate_number,
    isFooterWithBarcode ? "transparent" : "#ffffff"
  );

  var qrData = QR.drawImg(
    value?.qr,
    {
      typeNumber: 5,
      errorCorrectLevel: "M",
      size: 37
    }
  );


  return (
    <>
      <div
      style={outerStyle}>
          <img style={styles.bg_image} src={value?.background_image} alt="background images"/>
        <div style={{ ...styles.header_wrap, marginTop: t }}>
            <img style={headerImgStyle} src={value?.front_top_image || ""} alt="Header"/>
            {parseInt(value?.qr_and_image_format) === 2 && value?.qr && (
              <span style={qrWrapStyle}>
                <QRCode
                  value={value?.qr}
                  width={39.37}
                  height={39.37}
                  style={styles.qr_code}
                />
              </span>
            )}
            {/* {parseInt(value?.qr_and_image_format) === 2 && value?.qr && (
            <span style={qrWrapStyle}>
              <img src={qrData} alt="qrcode" style={styles.qr_code}/>
            </span>
          )} */}
        </div>
        <div style={bodyStyle}>
          <div style={{
            minHeight : middleArray?.length <= 6 ? 38 : "auto",
          }}>
            <div style={styles.row}>
              <p style={{...newKeyValue, lineHeight : arrayItems?.length <= 6 ? '1.3' : "1.2"}}>
                {value?.bold === 1 ? (
                  <b style={{fontWeight : "600"}}>SUMMARY NO</b>
                ) : "SUMMARY NO"}
              </p>
              <p style={{...styles.separate, lineHeight : arrayItems?.length <= 6 ? '1.3' : "1.2"}}>:</p>
              <p style={{...styles.value, lineHeight : arrayItems?.length <= 6 ? '1.3' : "1.2"}}>
                {value?.bold === 1 ? (
                  <b style={{fontWeight : "600"}}>{value?.certificate_number}</b>
                ): value?.certificate_number}
              </p>
            </div>
            {topArray?.map((item,index)=>(
              <div style={styles.row} key={index}>
                <p style={{...newKeyValue, lineHeight : arrayItems?.length <= 6 ? '1.3' : "1.2"}}>
                  {item?.bold === 1 ? (
                    <b style={{
                      fontSize : item?.text?.length >= 12 ? 8 : 'inherit', 
                      fontWeight : "600"
                    }}>{renderText(item?.text, item?.key_font_case)}</b>) : 
                      renderText(item?.text, item?.key_font_case)
                  }
                </p>
                <p style={{...styles.separate, lineHeight : arrayItems?.length <= 6 ? '1.3' : "1.2"}}>:</p>
                <p style={{...styles.value ,lineHeight : arrayItems?.length <= 6 ? '1.3' : "1.2"}}>
                  {item?.bold === 1 ? (
                    <b style={{
                      fontSize : item?.text?.length >= 12 ? 8 : 'inherit', 
                      fontWeight : "600"
                    }}>{renderText(item?.value, item?.value_font_case)}</b>
                    ) : renderText(item?.value, item?.value_font_case)
                  }
                </p>
              </div>
            ))}
            
          </div>
          <div style={styles.middle_wrap}>
            <div style={styles.content_wrap}>
              {middleArray?.map((item, index)=>(
                <div style={styles.row} key={index}>
                  <p style={{
                    ...newKeyValue, 
                    lineHeight : item?.bold === 1 ? '1.3' : (isLargeArray ? '1.3' : '1.6'),
                    }}>
                    {item?.bold === 1 ? (
                      <b style={{fontSize : item?.text?.length >= 12 ? 8 : 'inherit', fontWeight : "600"}}>{renderText(item?.text, item?.key_font_case)}</b>
                      ) : renderText(item?.text, item?.key_font_case)
                    }
                    
                  </p>
                  <p style={{...styles.separate, lineHeight : item?.bold === 1 ? '1.3' : (isLargeArray ? '1.3' : '1.6')}}>:</p>
                  <p style={{...styles.value, lineHeight : item?.bold === 1 ? '1.3' : (isLargeArray ? '1.3' : '1.6')}}>
                    {item?.bold === 1 ? (
                      <b style={{fontSize : item?.text?.length >= 12 ? 8 : 'inherit', fontWeight : "600"}}>{renderText(item?.value, item?.value_font_case)}</b>
                      ) : renderText(item?.value, item?.value_font_case)
                    }
                  </p>
                </div>
              ))}
            </div>
            <div style={styles.img_wrap}>
                <img style={styles.main_img} src={value?.image || ""} alt="Card images" />
            </div>
          </div>
          <div style={styles.bottom_wrap}>
            {bottomArray?.map((item, index)=>(
              <div style={styles.row} key={index}>
                <p style={{...newKeyValue, lineHeight : item?.bold !== 1 && isLargeArray ? '1.3' : '1.2'}}>
                  {item?.bold === 1 ? (
                    <b style={{fontSize : item?.text?.length >= 12 ? 8 : 'inherit', fontWeight : "600"}}>{renderText(item?.text, item?.key_font_case)}</b>
                    ) : renderText(item?.text, item?.key_font_case)
                  }
                </p>
                <p style={{...styles.separate, lineHeight : item?.bold !== 1 && isLargeArray ? '1.3' : '1.2'}}>:</p>
                <p style={{...styles.value, lineHeight : item?.bold !== 1 && isLargeArray ? '1.3' : '1.2',paddingRight : "2.3%"}}>
                  {item?.bold === 1 ? (
                    <b style={{fontSize : item?.text?.length >= 12 ? 8 : 'inherit', fontWeight : "600"}}>
                      {renderText(checkSyleCode(item?.value),item?.value_font_case)}</b>
                    ) : renderText(checkSyleCode(item?.value),item?.value_font_case)
                  }
                </p>
              </div>
            ))}
          </div>
        </div>
        <div style={styles.footer_wrap}>
          {
            isFooterWithBarcode ? (
              <div style={styles.footer_overlay_wrap}>
                <img
                  style={styles.footer_img}
                  src={value?.footer_background_image || ""}
                  alt="Card footer"
                />
                {value?.certificate_number && (
                  <span style={styles.footer_overlay_barcode}>
                    <img src={barcodeData} alt="barcode" style={styles.barcode} />
                  </span>
                )}
              </div>
            ) : parseInt(value?.footer_type) !== 2 ?(
              <div
              style={styles.barcode_wrap}
            >
              {value?.certificate_number && (
                // <Barcode
                // value={value?.certificate_number}
                // height={15}
                // width={0.5}
                // displayValue={false}
                // margin={0}
                // />
                <img src={barcodeData} alt="barcode" style={styles.barcode} />
              )}
            </div>
            ) :(
              <img style={styles.footer_img} src={value?.front_foot_image || ""} alt="Card footer"/>
            )
          }
        </div>
      </div>
    </>
  );
};

const styles = {
  outer_wrapper:  {
    width  :321,
    minWidth : 321,
    maxWidth : 321,
    height : 207,
    maxHeight : 207,
    minHeight : 207,
    border  : '1px solid #f3f3f3',
    color : "#000000",
    overflow : "hidden",
    fontFamily: "Graphik",
    backgroundColor : "#ffffff",
    position : "relative",
  },
  header_wrap : {
    display : "flex",
    alignItems : "center",
    maxWidth : '100%',
    height : 47.24,
    // height : '1.2cm'
    width : '100%',
    position : 'relative',
  },
  header_img :{
    maxWidth : 321,
    width : '100%',
    maxHeight : 47.24,
    height : 47.24,
  },
  qr_wrap : {
    width : 39.37, 
    height : 39.37, 
    display : "inline-block", 
    position : "absolute",
    top : 2,
    right : 7,
  },
  qr_code : {
    width: 39.37,
    height: 39.37,
  },
  footer_wrap : {
    height : 15,
    // height : '0.8cm'
    width : '100%',
    display : "flex",
    position : "relative"
  },
  footer_img :{
    width : '100%',
    maxHeight : 15,
    height : 15,
  },
  footer_overlay_wrap :{
    position : 'relative',
    width : '100%',
    height : 15,
    maxHeight : 15,
    lineHeight : 0,
  },
  footer_overlay_barcode :{
    position : 'absolute',
    top : 0,
    left : 0,
    width : '100%',
    height : '100%',
    display : "flex",
    alignItems : "center",
    justifyContent : "center",
    lineHeight : 0,
  },
  body: {
    height : 141.76,
    maxHeight : 141.76,
    padding : '1px 7px',
    display : "flex",
    flexDirection : "column",
    position : "relative",
  },
  middle_wrap: {
    display : 'flex',
    padding : '1px 0',
    // alignItems : "center",
    // flex :"1",
  },
  row :{
    display : 'flex',
    padding : '0.8px 0px'
  },
  key: {
    width: 73,
    fontSize: 8.5,
    fontWeight: 400,
    lineHeight: "1.1",
    marginBottom:0,
  },
  value: {
    flex : "1",
    verticalAlign: "top",
    fontWeight: 400,
    lineHeight: "1.1",
    marginBottom:0,
    fontSize : 8.5,
  },
  separate: {
    width: 10,
    paddingRight: 4,
    paddingLeft: 4,
    fontWeight : 400,
    fontSize:  8.5,
    lineHeight: "1.1",
    marginBottom:0,
    position: "relative",
    top: -1,
  },
  content_wrap :{
    flex : "1",
  },
  img_wrap : {
    width : 90,
    marginRight:4,
  },
  main_img :{
    width: '100%',
    maxWidth : 90,
    height : 60,
    maxHeight : 60,
  },
  barcode_wrap: {
    textAlign: "center",
    backgroundColor: "#ffffff",
    lineHeight: 0,
    width : "100%",
    display: "flex",
    alignItems : "center",
    justifyContent: "center",
  },
  footer_text :{
    textAlign : "center",
    width : "100%",
    position : "absolute",
    left : 0,
    bottom : 15,
  },
  bg_image: {
    position : "absolute",
    top : 0,
    left : 0,
    width : "100%",
    height : "100%",
  },
};
